import React from "react";

import { faThumbsUp } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Menu from "~/ui/menu";

import { type AbstractAction, ActionButton } from "./shared";

import suggestedActionsStyles from "./SuggestedActions.module.css";

const ACTION_ID = "give-feedback" as const;

export interface GiveFeedbackProps {
	openMeetingFeedbackModal: () => void;
}

function Button({ openMeetingFeedbackModal }: GiveFeedbackProps) {
	return (
		<ActionButton actionId={ACTION_ID} onClick={openMeetingFeedbackModal}>
			<FontAwesomeIcon icon={faThumbsUp} className={suggestedActionsStyles.actionButtonIcon} size="sm" />
			How was the meeting?
		</ActionButton>
	);
}

function MenuItem({ openMeetingFeedbackModal }: GiveFeedbackProps) {
	return (
		<Menu.Item icon={faThumbsUp} onSelect={openMeetingFeedbackModal}>
			How was the meeting?
		</Menu.Item>
	);
}

export default {
	id: ACTION_ID,
	button: Button,
	menuItem: MenuItem,
} satisfies AbstractAction;
